(function () {
  const noticeValueArray = document.querySelectorAll('.notice__contentTimerValue');
  const noticeButtonsArray = document.querySelectorAll('.notice__close');
  const copyLinks = document.querySelectorAll('.notice__content a[href="#copy"]');
  let noticesList = document.querySelectorAll('.notice__item:not(.notice__item--earlyAccess)');

  /*Cycle changing notices*/
  if (noticesList.length > 1) {
    const rotateTime = parseInt(document.querySelector('.noticeList').dataset.rotateTime);

    changeNotices(rotateTime);
  }

  function changeNotices(time) {
    setTimeout(() => {
      noticesList = document.querySelectorAll('.notice__item:not(.notice__item--earlyAccess');

      if (noticesList.length > 1) {
        const activItem = document.querySelector('.notice__item.notice__item--active');
        const currentItem = activItem.nextElementSibling.nextSibling && !activItem.nextElementSibling.nextSibling.matches('.notice__item--earlyAccess') ?
          activItem.nextElementSibling.nextSibling : noticesList[0];

        activItem.classList.remove('notice__item--active');
        currentItem.classList.add('notice__item--active');

        changeNotices(time);
      }
    }, time);
  }
  /*End cycle changing notices*/

  /* Timer*/
  if (noticeValueArray.length > 0) {
    noticeValueArray.forEach(notice => {
      let timer = notice.innerText.trim(),
          timerYear = parseInt(timer.substr(12, 4), 10),
          timerMonth = parseInt(timer.substr(9, 2), 10),
          timerDay = parseInt(timer.substr(6, 2), 10),
          timerHours = parseInt(timer.substr(3, 2), 10),
          timerMinutes = parseInt(timer.substr(0, 2), 10),
          countDownDate = new Date(timerYear, timerMonth - 1, timerDay, timerHours, timerMinutes).getTime();

      let x = setInterval(function() {
        let now = new Date().getTime(),
            distance = countDownDate - now,
            days = Math.floor(distance/1000/60/60/24),
            hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
            minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
            seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (days > 0) {
          hours = hours + (days * 24)
        }

        if (seconds < 10) {
          seconds = '0' + seconds;
        }

        if (minutes < 10) {
          minutes = '0' + minutes;
        }

        if (hours < 10) {
          hours = '0' + hours;
        }

        notice.innerHTML = hours + ":" + minutes + ":" + seconds;
        notice.closest('.notice__item').classList.remove('notice__item--loadHidden');

        if (distance < 0) {
          clearInterval(x);
          notice.innerHTML = "00:00:00";
        }
      }, 1000);
    });
  }
  /*End Timer*/

  function copyText(e) {
    e.preventDefault();

    const copiedText = '<span><strong>COPIED</strong></span>';
    const currentLink = e.currentTarget;

    navigator.clipboard.writeText(currentLink.innerText).then(() => {
      currentLink.classList.add('notice__copiedLink');
      currentLink.insertAdjacentHTML('beforeend', copiedText);

      setTimeout(() => {
        currentLink.classList.remove('notice__copiedLink');
        currentLink.querySelector('span').remove();
      }, 2000);
    });
  }

  if (noticeButtonsArray.length > 0) {
    (function() {
      let noticesArray = document.querySelectorAll('.notice__item');

      noticesArray.forEach(notice => {
        let noticeID = notice.dataset.notice;

        if (localStorage.getItem(noticeID)) {
          notice.remove();
        }
      });
    })();

    function closeNotice(event) {
      let currentButton = event.currentTarget,
          currentNotice = currentButton.closest('.notice__item'),
          currentItem = currentNotice.nextElementSibling.nextSibling ?
                        currentNotice.nextElementSibling.nextSibling : noticesList[0];

      currentNotice.remove();
      currentItem.classList.add('notice__item--active');
      localStorage.setItem(currentNotice.dataset.notice, true);

      setTimeout(() => {
        window.toggleContentGap();
      }, 400);
    }

    noticeButtonsArray.forEach(button => {
      button.addEventListener('click', event => {
        closeNotice(event);
      })
    });
  }

  if (copyLinks.length) {
    copyLinks.forEach((link) => {
      link.addEventListener('click', copyText);
    });
  }
})();